/**
 * ============================================================
 * Nederlands
 * ============================================================
 *
 * Translators:
 *
 * Natsukeep
 */

export default {
	'AdvanceHelp': 'Gebruik de spatiebalk of linker muisknop om te spelen',
	'AllowPlayback': 'Click here to allow audio playback',
	'Audio': 'Audio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Enable auto play',
	'AutoPlaySpeed': 'Autoplay snelheid',

	'Back': 'Terug',
	'BackButton': 'Terug',

	'Cancel': 'Stop',
	'Close': 'Sluit',
	'Confirm': 'Ben je zeker dat je wilt stoppen?',
	'Credits': 'Credits',

	'Delete': 'Delete',
	'DialogLogButton': 'Show the dialog log',

	'FullScreen': 'Volledig scherm',

	'Gallery': 'Gallery',

	'Help': 'Help',
	'Hide': 'Verberg',
	'HideButton': 'Verberg tekst',

	'KeyboardShortcuts': 'Keyboard Shortcuts',

	'iOSAudioWarning': 'Audio instellingen worden niet ondersteund door iOS',

	'Language': 'Taal',
	'Load': 'Laad',
	'LoadAutoSaveSlots': 'Automatisch opgeslagen spellen',
	'LoadButton': 'Open het laadscherm',
	'Loading': 'Laden',
	'LoadingMessage': 'Wacht tot de onderdelen zijn geladen',
	'LoadSlots': 'Opgeslagen spellen',
	'LocalStorageWarning': 'Locale Opslag is niet mogelijk in deze Browser',
	'Log': 'Log',

	'Music': 'Muziek Volume',

	'NewContent': 'There is new content available, reload the page to get the latest version',
	'NoSavedGames': 'Geen opgeslagen spellen',
	'NoAutoSavedGames': 'Geen automatsch opgeslagen spellen',
	'NoDialogsAvailable': 'No dialogs available. Dialogs will appear here as they show up',

	'OK': 'OK',
	'OrientationWarning': 'Please rotate your device to play',
	'Overwrite': 'Overschrijven',

	'QuickButtons': 'Snelmenu knoppen',
	'QuickMenu': 'Quick Menu',
	'Quit': 'sluit',
	'QuitButton': 'Sluit spel',

	'Resolution': 'Resolutie',

	'Save': 'Opslaan',
	'SaveButton': 'Open de Save Screen',
	'SaveInSlot': 'Sla op in slot',
	'Settings': 'Instellingen',
	'SettingsButton': 'Open de instellingen',
	'Show': 'Tonen',
	'Skip': 'Skip',
	'SkipButton': 'Enter skip mode',
	'SlotDeletion': 'Weet u zeker dat u dit slot verwijderen?',
	'SlotOverwrite': 'Weet u zeker dat u dit slot overschrijven?',
	'Sound': 'Geluids volume',
	'Start': 'Start',
	'Stop': 'Stop',

	'TextSpeed': 'Tekst snelheid',

	'Video': 'Video Volume',
	'Voice': 'Stem Volume',

	'Windowed': 'Window modus'
};